import React, { Component,Fragment } from "react";
import { Row, FormGroup, Input, CustomInput, Button } from "reactstrap";
import PerfectScrollbar from "react-perfect-scrollbar";

import { Colxx } from "../../components/common/CustomBootstrap";
import IntlMessages from "../../helpers/IntlMessages";

export default class ProductGrid extends Component {
	constructor(props) {
		super();
		this.state = {
			search:'',
			selected_sub_categories:[]
		}
		
		this.addToCart = this.addToCart.bind(this);
	}
	
	addToCart(product){
		var values={};
	
		
		values.product_id=product.id;
		values.product_price=product.product_price;
		values.product_unit_price=product.product_unit_price;		
		values.exise_tax=product.exise_tax;
		values.sales_tax=product.sales_tax;
		values.quantity=1;
		values.variation_id=product.variation_id;
		values.cost_per_unit=product.cost_per_unit;
		values.package_id=0;
		values.is_finished=0;
		values.stock_facility_id=product.stock_facility_id;
		
		this.props.addToCart(values);		
	}
	
	render() {
		const{ products, sub_categories, currency_rate, currency_symbol, index,allProducts, search } = this.props;
		console.log('searchsearchsearch11',search);
		 var final_products = products;
		
		var filterProducts = allProducts;
	
		
		if(typeof sub_categories!='undefined'){
			if(this.state.selected_sub_categories.length>0){
				final_products = final_products.filter(r=>{ return this.state.selected_sub_categories.indexOf(r.sub_category)!=-1 });
			}
		}
		if (this.state.search) {
			final_products = filterProducts.filter(row => {
				return  row.name.toLowerCase().includes(this.state.search.toLowerCase()) || row.barcode.includes(this.state.search)
			})
		}
		console.log('searchsearchsearch12',final_products);
		console.log('searchsearchsearch13',sub_categories);
		console.log('searchsearchsearch14',typeof sub_categories);
		return (<Fragment>
				<div className="mb-2 p-2 product-item-search dropdown-edit">						
					<FormGroup row className="mb-0">
						<Colxx lg="12">
							<Input
								type="text"
								name={"product_search"+index}
								id={"product_search"+index}
								placeholder="Search"
								value={this.state.search}
								onChange={e => this.setState({search: e.target.value.toLowerCase()})}
							/>
						</Colxx>
					</FormGroup>
					{typeof sub_categories!='undefined' ? (sub_categories.length>0 ? <div className="mt-2">
						<div className="d-flex justify-content-between">
							<h5 className="font-weight-bold">Sub Categories</h5>
							<div>
								<Button type="button" color="primary" size="xs" className="cursor-pointer" onClick={(e)=>{ this.setState({ selected_sub_categories:sub_categories.map(s=>s.category_id) }) }}  >
									Select All
								</Button>
								<Button color="primary" size="xs" className="cursor-pointer ml-2" onClick={(e)=>{ this.setState({ selected_sub_categories:[] }) }}  >
									Deselect All
								</Button>
							</div>
						</div>
						<div className="d-flex flex-wrap">
							{sub_categories.map(sub=>{
								return <CustomInput 
											type="checkbox" 
											label={sub.name}
											name={"category_id_"+sub.category_id}
											value={sub.category_id}
											id={"category_id_"+sub.category_id}									
											className="mr-2"
											checked={this.state.selected_sub_categories.indexOf(sub.category_id)!==-1}
											onChange={(e)=>{
												let selected_sub_categories = this.state.selected_sub_categories;
												if(selected_sub_categories.indexOf(sub.category_id)==-1){
													selected_sub_categories.push(sub.category_id);
												}else{
													selected_sub_categories = selected_sub_categories.filter(s=>{ return s!=sub.category_id });
												}
												this.setState({ selected_sub_categories })
											}}
										/>
							})}
						</div>
					</div>:""):""}
				</div>
				<PerfectScrollbar
				  option={{ suppressScrollX: true, wheelPropagation: false }}
				>
					<div className="d-flex flex-wrap">
					{final_products.map((row,index)=>{
						console.log('searchsearchsearch15', row)
						return(<Colxx md="3" xxl="2" className="text-center product-item" key={index} onClick={(e)=>{ if(row.unique_id!=1){ this.addToCart(row); }else{ this.props.toggleModalGetPackages(e,row.id); } }}>
							<img src={row.thumbnail_url} className="product-thumnail img-responsive" />	
							<p className="mt-1 mb-1 product-item-name">{row.name.toUpperCase()}</p>
							{/* <p className="mb-0 text-danger font-weight-bold">{currency_symbol+" "+(parseFloat(row.product_unit_price*currency_rate).toFixed(2))}</p> */}
						</Colxx>)
					})}					
					</div>
				</PerfectScrollbar>
				{/* <PerfectScrollbar
				  option={{ suppressScrollX: true, wheelPropagation: false }}
				>
					<div className="d-flex flex-wrap">
					{final_products.map((row,index)=>{
						return(<Colxx md="3" xxl="2" className="text-center product-item" key={index} onClick={(e)=>{ this.addToCart(row); }}>
							<img src={row.thumbnail_url} className="product-thumnail img-responsive" />	
							<p className="mt-1 mb-1 product-item-name">{row.name.toUpperCase()}</p> */}
							{/*<p className="mb-0 text-danger font-weight-bold">{currency_symbol}{" "+(parseFloat(row.product_unit_price*currency_rate).toFixed(2))}</p>*/}
						{/* </Colxx>)
					})}					
					</div>
				</PerfectScrollbar> */}
			</Fragment>);
	}
}
